(function () {
  var ns = (window.SpareParts = window.SpareParts || {});
  ns.helpers = ns.helpers || {};

  function renderMessage(target, message) {
    target.innerHTML =
      '<div class="spare-parts__message">' +
      ns.helpers.escapeHtml(message) +
      '</div>';
  }

  function renderTable(target, rows) {
    target.innerHTML = [
      '<div class="spare-parts__compat-body">',
      '<p class="spare-parts__compat-intro">This spare part will fit the following  products:</p>',
      '<div class="spare-parts__compat-filters"></div>',
      '<div class="spare-parts__compat-table-wrap">',
      '<table class="spare-parts__compat-table">',
      '<thead><tr><th>Series <span class="spare-parts__compat-sort">▲</span></th><th>Model</th><th>Rank</th><th>EV</th></tr></thead>',
      '<tbody></tbody>',
      '</table>',
      '</div>',
      '<div class="spare-parts__compat-note">',
      '<strong>Compatibility:</strong>',
      '<div>A Same parts.</div>',
      '<div>B Parts are usable, but differ in materials, appearance, finish, size, etc. Absence of mark indicates non-interchangeability.</div>',
      '</div>',
      '</div>'
    ].join('');

    var tbody = target.querySelector('tbody');
    var filtersEl = target.querySelector('.spare-parts__compat-filters');
    var seriesValues = Array.from(
      new Set(
        rows
          .map(function (row) {
            return row.series;
          })
          .filter(Boolean)
      )
    );

    var activeSeries = [];

    function drawTable() {
      var visibleRows = activeSeries.length
        ? rows.filter(function (row) {
            return activeSeries.indexOf(row.series) > -1;
          })
        : rows;

      tbody.innerHTML = visibleRows
        .map(function (row) {
          var model = row.model
            ? '<a href="/search?q=' + encodeURIComponent(row.model) + '">' + ns.helpers.escapeHtml(row.model) + '</a>'
            : 'N/A';

          return [
            '<tr>',
            '<td>' + ns.helpers.escapeHtml(row.series || 'N/A') + '</td>',
            '<td>' + model + '</td>',
            '<td>' + ns.helpers.escapeHtml(row.rank || 'N/A') + '</td>',
            '<td><a href="' + ns.helpers.escapeHtml(row.pdf_file_path) + '" target="_blank" rel="noreferrer">PDF</a></td>',
            '</tr>'
          ].join('');
        })
        .join('');
    }

    filtersEl.innerHTML = seriesValues
      .map(function (series, index) {
        var id = 'spare-parts-compat-' + index + '-' + series.replace(/\W+/g, '-').toLowerCase();
        return [
          '<label class="spare-parts__compat-filter" data-series-filter="', ns.helpers.escapeHtml(series), '">',
          '<input type="checkbox" id="', ns.helpers.escapeHtml(id), '" value="', ns.helpers.escapeHtml(series), '">',
          '<span>', ns.helpers.escapeHtml(series), '</span>',
          '</label>'
        ].join('');
      })
      .join('');

    filtersEl.addEventListener('change', function () {
      activeSeries = Array.from(filtersEl.querySelectorAll('input:checked')).map(function (input) {
        return input.value;
      });

      filtersEl.querySelectorAll('.spare-parts__compat-filter').forEach(function (label) {
        var input = label.querySelector('input');
        label.classList.toggle('is-active', !!(input && input.checked));
      });

      drawTable();
    });

    drawTable();
  }

  ns.loadCompatibility = async function (instance, sku, target) {
    target.innerHTML = '<div class="spare-parts__loading"></div>';

    try {
      var rows = await ns.helpers.fetchJson(instance.config.apiBase + '/spares', {
        sku: sku,
        account: instance.config.account
      });

      if (!Array.isArray(rows) || !rows.length) {
        renderMessage(target, 'No compatibility records were found for this spare part.');
        target.dataset.loaded = '1';
        return;
      }

      renderTable(target, rows);
      target.dataset.loaded = '1';
    } catch (error) {
      console.error('[Spares] compatibility fetch failed', error);
      renderMessage(target, 'Compatibility data is temporarily unavailable.');
    }
  };
})();
